import { createFileRoute } from '@tanstack/react-router';

import { equipmentDetailsSupportingRouteOptions } from '@/utils/equipment-details-route-params';

export const Route = createFileRoute('/$org/$agent/process-view')({
  ...equipmentDetailsSupportingRouteOptions('process-view'),
});
